module.exports = __webpack_public_path__ + "img/HLTW-page.758d9822.jpg";